import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Button, ButtonGroup } from 'reactstrap';
import withEditContext, { HasEditContext } from './withEditContext';
import RocTitle from '../RocTitle';
import AxiosHelper from '~/services/AxiosHelper';
import { toastError, toastSuccess } from '~/components/shared/toast/Toasts';
import Axios, { AxiosError } from 'axios';
import { EntityDefinition } from '~/types';
import Octicon, { Check } from '@githubprimer/octicons-react';

interface EditCopyHtmlButtonProps extends RouteComponentProps<any>, HasEditContext {
	entityDefinition: EntityDefinition;
}

/**
 * Component for coping the html markup
 */
function EditCopyHtmlButton(props: EditCopyHtmlButtonProps) {
	const {
		entityDefinition: { baseAjaxRoute },
		editContext,
	} = props;

	const handleClick = async () => {
		try {
			const response = await AxiosHelper.get(`${baseAjaxRoute}/${editContext.values.id}`);

			if (!response.data.entity.body) {
				toastError({ content: { message: 'There is no valid HTML markup to copy.' } });
				return;
			}

			navigator.clipboard.writeText(response.data.entity.body);
			toastSuccess({
				content: {
					message: `HTML markup copied to clipboard.`,
				},
			});
		} catch (error) {
			if (!Axios.isCancel(error)) {
				console.log(error as AxiosError);
			}

			toastError({ content: { message: 'HTML markup copy failed.' } });
		}
	};

	return (
		<div className="edit-form__actions-bar-item">
			<RocTitle label="Copy HTML" alignment="left">
				<ButtonGroup>
					<Button color="primary" className="btn-medium" onClick={handleClick} data-testid="copy-html-button">
						<div className="btn-icon-text-container">
							<span className="btn-icon-bg">
								<Octicon icon={Check} ariaLabel="Checkmark" />
							</span>
							<span className="btn-icon-text">Copy Html</span>
						</div>
					</Button>
				</ButtonGroup>
			</RocTitle>
		</div>
	);
}

export default withEditContext(EditCopyHtmlButton);
